import { getLink } from "../../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Min ne forgesu dum la voj’, <br/>
        En sonĝo ne forgesu min! <br/>
        Mildiĝos vento kaj malĝoj’, <br/>
        La hejm’ ne plu altiros vin. <br/>
        Mi scias, akvo de la mar’ <br/>
        La amon ŝanĝas al amar’, <br/>
        Sed kial? – Ĝi ne diras, ĉar <br/>
        Senvorte fluas onda ar’, <br/>
        La onda fluas ar’…
      </p>

      <p class="poem-block mb-3">
        Sopiras mi dum tuta jar’, <br/>
        Kaj vane serĉas vin apel’. <br/>
        Ho, estu firma via vel’ <br/>
        Dum ŝtormoj en la alta mar’, <br/>
        Ne falu masto dum venteg’. <br/>
        Se nigra iĝos la ĉiel’ <br/>
        Kaj bluaj ondoj – griza greg’, <br/>
        Tiam – protektu, Dio, vin! <br/>
        Protektu vin, anĝel’!
      </p>

      <p class="poem-block mb-3">
        Ŝpinadas-teksas mi sen ĉes’, <br/>
        Kaj ne laciĝas mia man’. <br/>
        Mi scias fari laŭ neces’ <br/>
        La tolon, ŝnuron, ion ajn! <br/>
        L’ maristo viva venu nur! <br/>
        Ne prenu lin la mara ond’! <br/>
        Se ne revenos – forta ŝnur’ <br/>
        Jam pretos kun fidinda nod’, <br/>
        Fidinda pretos nod’! <br/>
        Por mi ja pretos nod’!
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Irlanda kanteto'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['oVQQULakxz4&start=7888&end=8037'],
    itemTranslator: translator.esp
  }
}

export default item;